import { Space } from '../enums/space.enum';

// The id of the list holding the pages of each space in the main menu.
export const SPACE_LIST_ID: Readonly<Record<Space, string>> = {
  [Space.Main]: 'app-menu-main-space',
  [Space.Folder]: 'app-menu-folder-space',
  [Space.Mission]: 'app-menu-mission-space',
  [Space.SubMission]: 'app-menu-sub-mission-space',
  [Space.MasterData]: 'app-menu-master-data-space',
  [Space.References]: 'app-menu-references-space',
  [Space.Admin]: 'app-menu-admin-space',
};
